import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
import React from 'react';
import { Map as GoogleMap, GoogleApiWrapper, Marker, InfoWindow } from 'google-maps-react';
import Geocode from 'react-geocode';
import { LocationPropType } from '../../services/proptypes';
import './map-multilocation.css';
function getAddressFromLocation(location) {
  // eslint-disable-next-line camelcase
  var street = location.street,
    city = location.city,
    state = location.state,
    zip_code = location.zip_code,
    country = location.country;
  // eslint-disable-next-line camelcase
  return "".concat(street, ", ").concat(city, ", ").concat(state, ", ").concat(zip_code, ", ").concat(country);
}
var MapMultilocation = /*#__PURE__*/function (_React$Component) {
  _inherits(MapMultilocation, _React$Component);
  var _super = _createSuper(MapMultilocation);
  function MapMultilocation(props) {
    var _this;
    _classCallCheck(this, MapMultilocation);
    _this = _super.call(this, props);
    _this.state = {
      markers: [],
      activeMarker: null,
      bounds: null,
      showingInfoWindow: false
    };
    _this.onMarkerClick = _this.onMarkerClick.bind(_assertThisInitialized(_this));
    _this.onMapClicked = _this.onMapClicked.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(MapMultilocation, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      var apiKey = process.env.STORYBOOK_MAPS_API_KEY;
      var locations = this.props.locations;
      locations.forEach(function (location) {
        var address = getAddressFromLocation(location);
        Geocode.fromAddress(address, apiKey).then(function (geocodeData) {
          _this2.addMarker(location, address, geocodeData);
        });
      });
    }
  }, {
    key: "onMarkerClick",
    value: function onMarkerClick(props, marker) {
      this.setState({
        activeMarker: marker,
        showingInfoWindow: true
      });
    }
  }, {
    key: "onMapClicked",
    value: function onMapClicked() {
      var showingInfoWindow = this.state.showingInfoWindow;
      if (showingInfoWindow) {
        this.setState({
          activeMarker: null,
          showingInfoWindow: false
        });
      }
    }
  }, {
    key: "addMarker",
    value: function addMarker(location, address, geocodeData) {
      var latLongData = geocodeData.results[0].geometry.location;
      var markers = this.state.markers;
      var newMarkers = [];
      newMarkers.push.apply(newMarkers, _toConsumableArray(markers));
      newMarkers.push({
        key: newMarkers.length,
        title: location.location_name,
        address: address,
        lat: latLongData.lat,
        lng: latLongData.lng
      });
      this.updateBounds(newMarkers);
      this.setState({
        markers: newMarkers
      });
    }
  }, {
    key: "updateBounds",
    value: function updateBounds(markers) {
      var bounds = new window.google.maps.LatLngBounds();
      markers.forEach(function (marker) {
        var latLng = new window.google.maps.LatLng(marker.lat, marker.lng);
        bounds.extend(latLng);
      });
      this.setState({
        bounds: bounds
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var google = this.props.google;
      var _this$state = this.state,
        bounds = _this$state.bounds,
        markers = _this$state.markers,
        activeMarker = _this$state.activeMarker,
        showingInfoWindow = _this$state.showingInfoWindow;
      return /*#__PURE__*/React.createElement("div", {
        className: "map-multilocation-wrapper"
      }, /*#__PURE__*/React.createElement(GoogleMap, {
        google: google,
        bounds: bounds,
        zoom: 16,
        onClick: this.onMapClicked
      }, markers.map(function (mrkr) {
        return /*#__PURE__*/React.createElement(Marker, {
          key: mrkr.key,
          onClick: _this3.onMarkerClick,
          title: mrkr.title,
          address: mrkr.address,
          position: {
            lat: mrkr.lat,
            lng: mrkr.lng
          }
        });
      }), /*#__PURE__*/React.createElement(InfoWindow, {
        marker: activeMarker,
        visible: showingInfoWindow
      }, /*#__PURE__*/React.createElement("div", null, activeMarker && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h4", {
        style: {
          marginBottom: '0'
        }
      }, activeMarker.title), /*#__PURE__*/React.createElement("p", null, activeMarker.address))))));
    }
  }]);
  return MapMultilocation;
}(React.Component);
MapMultilocation.defaultProps = {
  locations: []
};
export default GoogleApiWrapper({
  apiKey: process.env.GOOGLE_MAPS_API_KEY
})(MapMultilocation);